import { hasKey, isType } from './typeGuards';

const dotWalk = (object: unknown, path: string | string[]): unknown => {
  const fields = isType(path, 'array') ? path : path.split('.');

  return fields.reduce((result, field) => {
    if (hasKey(result, field)) {
      return result[field];
    }
    return undefined;
  }, object);
};

export default dotWalk;
